/**
 * Calculate the number of days until a trial ends.
 * @param trialEnd
 * @returns {number}
 */
export const daysUntilTrialEnd = (trialEnd) => {
  const end = Date.parse(trialEnd);
  const now = new Date();
  if (end && end > now) {
    return Math.ceil((end - now) / (1000 * 3600 * 24));
  }
  return 0;
};

/**
 * Sort by newest.
 * @param a
 * @param b
 * @returns {number}
 */
export const sortByNewest = (a, b) => {
  return new Date(a.createdAt) - new Date(b.createdAt);
};

/**
 * Generate a message for a subscription change.
 * - 'Your subscription has been updated to A, B and C'
 * - 'Your subscription has been updated to A and B'
 * - 'Your subscription has been updated to A'
 * - 'Your subscription has been updated'
 * @param plans
 * @returns {string}
 */
export const subscriptionUpdatedMessage = (plans = []) => {
  const planNames = plans.map(plan => plan.planName);
  if (planNames.length > 1) {
    return `Your subscription has been updated to ${planNames.slice(0, -1).join(', ')} and ${planNames[planNames.length - 1]}`;
  } else if (planNames.length === 1) {
    return `Your subscription has been updated to ${planNames[0]}`;
  } else {
    return `Your subscription has been updated`;
  }
}

/**
 * Generate a message for a subscription trial ending.
 * - 'Your organization's trial will expire in X days. Upgrade to continue using A, B and C'
 * - 'Your organization's trial will expire in X days. Upgrade to continue using A and B'
 * - 'Your organization's trial will expire in X days. Upgrade to continue using A'
 * - 'Your organization's trial will expire in X days'
 * @param plans
 * @param days
 * @returns {string}
 */
export const subscriptionTrialWillEndMessage = (plans = [], days = 0) => {
  const planNames = plans.map(plan => plan.planName);
  const daysText = days > 1 ? 'days' : 'day';
  if (planNames.length > 1) {
    return `Your organization's trial will expire in ${daysText}. Upgrade to continue using ${planNames.slice(0, -1).join(', ')} and ${planNames[planNames.length - 1]}`;
  } else if (planNames.length === 1) {
    return `Your organization's trial will expire in ${daysText}. Upgrade to continue using ${planNames[0]}`;
  } else {
    return `Your organization's trial will expire in ${daysText}`;
  }
}
